module.exports = __webpack_public_path__ + "static/paul-graham-99474e48f56449f44fec055ba58137a8.jpg";